import { render } from "./ManageLibrariesModal.vue?vue&type=template&id=8a9fddbe"
import script from "./ManageLibrariesModal.vue?vue&type=script&lang=js"
export * from "./ManageLibrariesModal.vue?vue&type=script&lang=js"

import "./ManageLibrariesModal.vue?vue&type=style&index=0&id=8a9fddbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__